import Abp from '../Abp/Abp'
let host = ''
if(process.env.NODE_ENV == 'development'){
    //var Requests = axios.create({baseURL:'http://192.168.0.66'});
    // host = 'https://mtapi.preview.52bkb.com'
    host = 'https://mtapi.test.52bkb.com'
    //var Requests = axios.create({baseURL:'http://2503b9d0.123nat.com:8010'});
}else{
    // host = 'https://mtapi.preview.52bkb.com'
    host = 'https://mtapi.test.52bkb.com'
}
class API {
    constructor() {
        this.Host = host
    }
    /*-----------------------------鼠标码-------------------------*/
    // 查询鼠标码
    GetMouse (code){
        var url = encodeURI(`api/v1/crm/mouse/${code}`)
        return Abp.Requests.get(url)
    }
    // 增加鼠标码
    CreateMouse (data) {
        return Abp.Requests.post('api/v1/crm/mouse/add',data)
    }
    // 获得鼠标的详细信息
    GetMouseDetail (code) {
        var url = encodeURI(`api/v1/crm/mouse/${code}/detail`)
        return Abp.Requests.get(url)
    }
    //批量增加鼠标码
    batchCreateMouse (data) {
        return Abp.Requests.post('api/v1/crm/mouse/addbatch',data)
    }

    // 删除鼠标
    DeleteMouse (data) {
        return Abp.Requests.patch('api/v1/crm/mouse/delete',data)
    }
    // 回收鼠标
    RecycleMouse (code) {
        var url = encodeURI(`api/v1/crm/mouse/${code}/recycle`)
        return Abp.Requests.put(url)
    }
    // 更换鼠标
    ReplaceMouse (code) {
        var url = encodeURI(`api/v1/crm/mouse/${code.oldcode}/replace/${code.newcode}`)
        return Abp.Requests.put(url)
    }
    // 修改鼠标信息
    UpdateMouse (data) {
        return Abp.Requests.put('api/v1/crm/mouse/update',data)
    }
    // 获得所有代理商信息
    GetAgents () {
        return Abp.Requests.get('api/v1/crm/agent/list')
    }
    //获取代理商信息
    GetAgent (id) {
        var url = encodeURI(`api/v1/crm/agent/${id}`)
        return Abp.Requests.get(url)
    }
    //创建代理商
    CreateAgent (data) {
        return Abp.Requests.post('api/v1/crm/agent/create',data)
    }
    //	删除代理商  
    DeleteAgent (id) {
        var url = encodeURI(`api/v1/crm/agent/delete?id=${id}`)
        return Abp.Requests.delete(url)
    }
    //获取代理商列表  根据推荐人和关键词查询代理商，没有参数则为全部，供后台使用
    BackendRetrieveAgent (data) {
        return Abp.Requests.post('api/v1/crm/agent/backendretrieveagent',data)
    }
    //	根据学校和关键词查询老师
    TeacherList (data) {
        return Abp.Requests.post('api/v1/org/teacher/list',data)
    }
    //	根据区域选择学校，具体到区县,后台使用
    GetSchoolByAreaID (areaId) {
        var url = encodeURI(`api/v1/org/school/areaschool?areaId=${areaId}`)
        return Abp.Requests.get(url)
    }
    // 修改代理商信息
    UpdateAgentInfo (data) {
        return Abp.Requests.put('api/v1/crm/agent/updateagentInfo',data)
    }
    // 修改代理商信息   重置密码
    ResetAgentPassword (data) {
        return Abp.Requests.put('api/v1/crm/agent/resetagentpassword',data)
    }
    //设置/取消老师为首推人
    SetSpread (data) {
        return Abp.Requests.put('api/v1/crm/recommend/setspread',data)
    }
    //添加/修改鼠标出货记录，客服调用
    AddOutMouse (data) {
        return Abp.Requests.put('api/agent/v1/addoutmouse',data)
    }
    //发货填写快递信息，修改订单状态 ，客服调用
    AddExpressInfo (data) {
        return Abp.Requests.put('api/agent/v1/addexpressinfo',data)
    }
    //查询出货记录,参数为空则查询全部
    OutBatchList (data) {
        return Abp.Requests.post('api/agent/agent/outbatch',data)
    }
    //查询出货记录包含的鼠标
    OutMouseList (data) {
        return Abp.Requests.post('api/v1/crm/agent/outmouse',data)
    }
    //	确认收货状态
    ConfirmReceive (data) {
        return Abp.Requests.post('api/v1/crm/agent/confirmreceive',data)
    }
    //鼠标激活确认列表，后台客服调用
    ConfrimMouseList (data) {
        return Abp.Requests.post('api/v1/crm/mouse/serverconfrimmouselist',data)
    }
    //鼠标激活确认详情，后台客服调用
    ServerConfrimMouse (data) {
        return Abp.Requests.post('api/v1/crm/mouse/serverconfrimmouse',data)
    }
    //获得所有直销员信息
    GetSalers () {
        return Abp.Requests.get('api/v1/crm/saler/list')
    }
    //获得直销员信息
    GetSaler (id) {
        var url = encodeURI(`api/v1/crm/saler/${id}`)
        return Abp.Requests.get(url)
    }
        //代理商新订单数量
    AgentNewOrderAmount () {
        var url = encodeURI(`api/notify/read/agentneworderamount`)
        return Abp.Requests.get(url)
    }
    //消息已读
    SetNotifyRead (NotifyID) {
        var url = encodeURI(`api/v1/agentnotify/read/${NotifyID}`);
        return Abp.Requests.get(url)
    }
    /*-----------------------------学校-------------------------*/
    //获取学校地区
    GetAreas(){
        var url =encodeURI(`api/v1/dict/code_area/list`)
        return Abp.Requests.get(url)
    }
    //获取某地区的所有学校，不包含已删除的学校
    GetSchoolsOfArea(id){
        var url = encodeURI(`api/v1/org/area/${id}/school/list`)
        return Abp.Requests.get(url)
    }
    // 获取学校详情
    GetSchoolDetail(schoolID){
        var url = encodeURI(`api/v1/org/school/${schoolID}/detail`)
        return Abp.Requests.get(url)
    }
    //添加学校
    AddSchool(data){
        return Abp.Requests.post('api/v1/org/school/add',data)
    }
    // 更新学校信息
    UpdateSchool(data){
        return Abp.Requests.put('api/v1/org/school/update',data)
    }
    // 获取学校名称中包含关键字的学校列表
    GetSchoolsLikeName (name) {
        var url = encodeURI(`api/v1/org/school/like/${name}/list`)
        return Abp.Requests.get(url)
    }
    // 删除学校
    DeleteSchool (data) {
        return Abp.Requests.patch('api/v1/org/school/delete',data)
    }
    // 获取学校的拓展信息
    GetSchool (schoolID) {
        var url = encodeURI(`api/v1/org/school/${schoolID}`)
        return Abp.Requests.get(url)
    }
    /*---------------------------组织机构------------------------*/
    //新增组织机构
    AddOrganization(data){
        return Abp.Requests.post('api/v1/org/education/addrganization',data)
    }
    //修改组织机构
    Alterorganinfo(data){
        return Abp.Requests.post('api/v1/org/education/alterorganinfo',data)
    }
    //删除组织机构
    Deleteorganinfo(data){
        return Abp.Requests.post('api/v1/org/education/deleteorganinfo',data)
    }
    //获取组织机构列表
    GetOrgList(data){
        return Abp.Requests.post('api/v1/org/education/organinfo',data)
    }
    //获取组织机构详情
    GetOrgDetails(orgId){
        var url = encodeURI(`api/v1/org/education/orgdeatil/${orgId}`)
        return Abp.Requests.get(url)
    }
    //新增机构用户
    addorguser(data){
        return Abp.Requests.post('api/v1/org/education/addorguser',data)
    }
    //获取组织机构下用户列表
    GetOrgUser(orgId){
        var url = encodeURI(`api/v1/org/education/orguser/${orgId}`)
        return Abp.Requests.get(url)
    }
    /* -----------------------------公司员工信息-------------------------------- */
    //添加销售员
    Salemans(data){
        return Abp.Requests.post('api/v1/salespace/salemans',data)
    }
    //查看公司员工列表
    Retrieve(){
        var url = encodeURI(`api/v1/salespace/salemans/retrieve`)
        return Abp.Requests.get(url)
    }
    //公司角色列表
    getRoles(){
        var url = encodeURI(`api/v1/salespace/salemans/role`)
        return Abp.Requests.get(url)
    }
    //公司员工详细信息
    getDetail(userID){
        var url = encodeURI(`api/v1/salespace/salemans/detail/${userID}`)
        return Abp.Requests.get(url)
    }
    //修改销售员
    updateSalemans(data){
        return Abp.Requests.post('api/v1/salespace/salemans/update',data)
    }
    /*-----------------------------角色-------------------------*/
    // 得到所有角色（包含禁用的）
    GetAllRoles () {
        return Abp.Requests.get('api/v1/admin/role/list')
    }
    // 得到角色授予的权限集合
    GetPrivilegesOfRole (roleID) {
        var url = encodeURI(`api/v1/admin/role/${roleID}/privilege/list`)
        return Abp.Requests.get(url)
    }
    // 给角色授予权限，如果权限为空则表示清空角色的权限
    GrantPrivileges (data) {
        return Abp.Requests.post('api/v1/admin/role/grant/privilege',data)
    }
    /*-----------------------------权限-------------------------*/
    // 获得所有权限定义
    GetPrivileges () {
        return Abp.Requests.get('api/v1/admin/privilege/list')
    }
    // 创建新的权限，根权限的PID设置为0
    CreatePrivilege (data) {
        return Abp.Requests.post('api/v1/admin/privilege/add',data)
    }
    // 更改权限属性，包括父子关系
    UpdatePrivilege (data) {
        return Abp.Requests.put('api/v1/admin/privilege/update',data)
    }
    // 删除权限，只能删除不包含子的权限
    DeletePrivilege (privilegeID) {
        var url = encodeURI(`api/v1/admin/privilege/${privilegeID}/delete`)
        // return Abp.Requests.delete(url)
        return Abp.Requests.patch(url)
    }
    // 获取校长列表
    GetMasterList (data) {
        return Abp.Requests.post('api/v1/org/master/list',data)
    }
    // 重置密码
    ReplacePwd (data) {
        return Abp.Requests.post('api/v1/org/master/replacepwd',data)
    }
    // 校长帐号停用、启用
    SetMasterState (data) {
        return Abp.Requests.post('api/v1/org/master/setstate',data)
    }
    // 创建校长
    CreateMaster (data) {
        return Abp.Requests.post('api/v1/admin/master/create',data)
    }
    // 获取存有校长角色的学校
    GetMasterSchool () {
        return Abp.Requests.get('api/v1/org/master/school')
    }
    // 教辅材料分页查询
    GetReference (data) {
        return Abp.Requests.post('api/v1/cloud/reference/referencelist',data)
    }
    // 新增教辅材料
    AddReference (data) {
        return Abp.Requests.post('api/v1/cloud/reference/insert',data)
    }
    // 修改教辅材料
    UpdateReference (data) {
        return Abp.Requests.post('api/v1/cloud/reference/update',data)
    }
    // 删除教辅材料
    DeleteReference (data) {
        return Abp.Requests.delete(`api/v1/cloud/reference/${data}/delete`)
    }
    // 获取教辅页面内容
    GetReferencePage (data) {
        return Abp.Requests.post('api/v1/cloud/reference/getpage',data)
    }
    // 新增教辅材料
    AddReference (data) {
        return Abp.Requests.post('api/v1/cloud/reference/insert',data)
    }
    // 获取全部学段学科列表
    GetStageSubjectList () {
        return Abp.Requests.get('api/v1/dict/stagesubject/list')
    }
    // 获取字典表内容
    GetDictionary (data) {
        return Abp.Requests.get(`api/v1/dict/${data}/list`)
    }
    // 查询代理商负责的区域和学校，后台客服调用
    ReadAgentAreaByService (data) {
        return Abp.Requests.post('api/v1/crm/service/readagentareaandschool',data)
    }
    // 添加代理区域（多个），后台客服调用
    ServicerCreateArea (data) {
        return Abp.Requests.post('api/v1/crm/agent/createagentarea',data)
    }
    // 删除代理商代理区域(多个)，后台客服调用
    ServicerDeleteArea (data) {
        return Abp.Requests.post('api/v1/crm/agent/deleteagentarea',data)
    }
    // 创建代理商负责的学校(多个),后台客服调用
    AgentCreateSchool (data) {
        return Abp.Requests.post('api/v1/crm/agent/agentcreateschool',data)
    }
    // 删除代理商负责的学校(多个),后台客服调用
    DeleteAgentSchool (data) {
        return Abp.Requests.post('api/v1/crm/agent/deleteagentschool',data)
    }
    // 设置/取消封闭某个学校,后台客服调用
    SetLockSchool (data) {
        return Abp.Requests.post('api/servicer/v1/lock/school',data)
    }
    // 设置/取消封闭某个区域,后台客服调用
    SetLockArea (data) {
        return Abp.Requests.post('api/servicer/v1/lock/area',data)
    }
    // 到期的封锁区域，后台客服调用
    ExpireLockArea (data) {
        return Abp.Requests.post('api/servicer/v1/expire/area',data)
    }
    // 到期的封锁学校，后台客服调用
    ExpireLockArea (data) {
        return Abp.Requests.post('api/servicer/v1/expire/school',data)
    }
    // 查询推荐的代理商列表（通过填写表单推荐），客服调用
    RecommendAgentList (data) {
        return Abp.Requests.post('api/v1/crm/recommend/agentlist',data)
    }
    // 查询老师填写需求单，客服调用
    TeacherNeedsList (data) {
        return Abp.Requests.post('api/v1/crm/recommend/needslist',data)
    }
    // 鼠标待审核列表，后台客服调用
    MouseWaitAudit (data) {
        return Abp.Requests.post('api/maintenance/v1/mouse/waitaudit',data)
    }
    // 邀请关系列表，后台客服调用
    RelationSearch (data) {
        return Abp.Requests.post('api/servicer/v1/relationsearch',data)
    }
    // 重置用户密码，后台客服调用
    RestPassword (data) {
        return Abp.Requests.post('api/servicer/v1/resetpassword',data)
    }
    // 给代理商返钱，后台客服调用
    BackMoneyToAgent (data) {
        return Abp.Requests.post('api/servicer/v1/backmoneytoagent',data)
    }
    /*-----------------------------更改密码-------------------------*/
    UpdateTeacherPassword (data) {
        return Abp.Requests.put('api/v1/admin/update/password',data)
    }
    /*-----------------------------消息提示-------------------------*/
    reqSuccess(obj,msg){
        obj.$message({
            message: msg,
            type: 'success'
        });
	}
	reqFail(obj,msg){
        obj.$message({
            message: msg,
            type: 'error'
        });
	}
    reqWarn(obj,msg){
        obj.$message({
            message: msg,
            type: 'warning'
        });
	}
 }
 const api = new API();
 export default api;


// WEBPACK FOOTER //
// ./src/data/api.js